import React, { useState } from 'react';

import { ActionIcon } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

import { PatientData } from '@/types/patientList';

import { PatientOptionsMenu } from '../PatientOptionsMenu';

import styles from './cells.module.scss';

interface OptionsCellProps {
  patient: PatientData;
}

export const OptionsCell: React.FC<OptionsCellProps> = ({ patient }) => {
  const [menuOpened, setMenuOpened] = useState(false);

  return (
    <PatientOptionsMenu patient={patient} opened={menuOpened} onOpenChange={setMenuOpened}>
      <ActionIcon variant="subtle" className={styles.optionsCell}>
        <IconDotsVertical style={{ width: '70%', height: '70%' }} stroke={2.5} />
      </ActionIcon>
    </PatientOptionsMenu>
  );
};
